export const PGR_EMPLOYEE_COMPLAINT_DETAILS = "/complaint/details/";
export const PGR_EMPLOYEE_CREATE_COMPLAINT = "/complaint/create";
